import { Helmet } from '@dr.pogodin/react-helmet';

const PaymentPlans: React.FC = () => {

  return (
    <>
      <Helmet>
        <title>Payment Plans | Atomic Tattoo Removal</title>
        <meta
          name="description"
          content="Explore flexible payment plans for laser tattoo removal at Atomic Tattoo Removal. Use our Cherry widget to see your options and get started today."
        />
      </Helmet>
      <div className="max-w-3xl mx-auto p-4">
        <h1 className="text-2xl font-bold text-blue-900 mb-4 text-center">Flexible Payment Plans</h1>
        <p className="text-center mb-6 text-gray-700">
          We offer convenient payment plans through Cherry so you can get started with your tattoo removal treatment right away. Explore your options below!
        </p>
        <iframe
          src="/cherry.html"
          title="Cherry Payment Plans"
          style={{ width: '100%', height: '400px', border: '1px solid #5c96ac', borderRadius: '8px', overflowY: 'scroll' }}
        />        
        <div id="all"></div>
      </div>
    </>
  );
};

export default PaymentPlans;